import * as React from 'react'
import styled from 'styled-typed'
import { ForgotPasswordContainer, ForgotPasswordForm, ForgotPasswordHeader, ValidationMessage } from 'auth/components'
import { IconTextInput } from 'uiComponents/input'
import { ActionButton } from 'uiComponents/buttons'
import { isValidEmail } from 'utils/formFieldChecks'
import { t, Trans } from 'translations'

export interface ForgotPasswordPageProps {
    resetPassword: (email: string) => Promise<boolean>
}

export interface ForgotPasswordPageState {
    message: string | null
    email: string
    success: boolean
}

const SuccessMessage = styled.div`
    margin-top: 1em;
    color: ${(props) => props.theme.colors.status.success};
`

export class ForgotPasswordPage extends React.Component<ForgotPasswordPageProps, ForgotPasswordPageState> {
    state = {
        message: null,
        email: '',
        success: false,
    }

    checkValidEmail = () => {
        if (!isValidEmail(this.state.email)) {
            this.setState({ message: t('auth.forgotPassword.invalidEmail') })
        } else {
            this.setState({ message: '' })
        }
    }

    sendResetEmail = async (e: React.FormEvent<HTMLElement>) => {
        e.preventDefault()
        try {
            this.setState({ message: '' })
            const result = await this.props.resetPassword(this.state.email)
            if (!result) {
                this.setState({
                    message: t('auth.forgotPassword.noMatchingAccount'),
                })
                return
            }
            this.setState({
                success: true,
            })
        } catch (e) {
            this.setState({
                message: t('auth.forgotPassword.unknownError'),
            })
        }
    }

    render() {
        const canSubmit = this.state.email.length > 0 && isValidEmail(this.state.email)

        return (
            <>
                <ForgotPasswordContainer>
                    <ForgotPasswordForm noValidate onSubmit={this.sendResetEmail}>
                        <ForgotPasswordHeader>{t('auth.forgotPassword.title')}</ForgotPasswordHeader>
                        <ValidationMessage className={this.state.message ? 'validation-message-visible' : ''}>
                            {this.state.message}
                        </ValidationMessage>
                        <IconTextInput
                            block
                            type="email"
                            status={this.state.message ? 'error' : 'normal'}
                            placeholder={t('auth.forgotPassword.emailPlaceholder')}
                            value={this.state.email}
                            onChange={(evt) => this.setState({ email: evt.target.value, success: false })}
                            onFinishTyping={this.checkValidEmail}
                            style={{ marginBottom: '.9em' }}
                        />
                        <ActionButton size="large" type="submit" disabled={!canSubmit} style={{ margin: '1em 3.5em' }}>
                            {t('auth.forgotPassword.sendResetEmail')}
                        </ActionButton>
                    </ForgotPasswordForm>
                    {this.state.success && (
                        <SuccessMessage>
                            <Trans
                                i18nKey="auth.forgotPassword.emailSent"
                                values={{ email: this.state.email }}
                                components={{ b: <b /> }}
                            />
                        </SuccessMessage>
                    )}
                </ForgotPasswordContainer>
            </>
        )
    }
}
